import { Formik } from 'formik'
import React from 'react'
import { Button, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import GroupStatus from "Components/IconDropdown/Cross_Tick/GroupStatus";

const EvalulerenModal = ({ toggleEvalulerenModal, evalulerenModalData, showEvalulerenModal, handleEvalulerenSubmit }) => {

    const getInitialValues = () => {
        const evalImage = evalulerenModalData?.evalImage || '';
        const evalMailBothClick = evalulerenModalData?.evalMailBothClick || '';
        
        if (!evalImage || evalImage === '') {
            return {
                emailToSchool: 0,
                emailToVervanger: 0
            };
        }
        
        if (evalImage === 'both' || evalMailBothClick === 'both') {
            return {
                emailToSchool: 1,
                emailToVervanger: 1
            };
        }
        
        if (evalImage === 'school') {
            return {
                emailToSchool: 1,
                emailToVervanger: evalMailBothClick === 'vervanger' ? 1 : 0
            };
        }
        
        if (evalImage === 'vervanger') {
            return {
                emailToSchool: 0,
                emailToVervanger: 1
            };
        }
        
        if (evalMailBothClick === 'vervanger') {
            return {
                emailToSchool: 1,
                emailToVervanger: 1
            };
        }
        
        return {
            emailToSchool: 1,
            emailToVervanger: 1
        };
    };

    const initialValue = getInitialValues();

    return (
        <Modal isOpen={showEvalulerenModal} toggle={() => toggleEvalulerenModal()} className="feedback-modal-style link-form dagtype-modal">
            <ModalHeader toggle={() => toggleEvalulerenModal()}>
                Uitnodiging tot evalueren
            </ModalHeader>
            <ModalBody>
                <Formik
                    initialValues={initialValue}
                    onSubmit={(values, { setSubmitting, setFieldError }) => handleEvalulerenSubmit(values, setSubmitting, setFieldError)}
                >
                    {({ setFieldValue, handleSubmit, values, isSubmitting, errors }) => (
                        <Form onSubmit={handleSubmit}>

                            <FormGroup className="d-flex justify-content-between">
                                <Label for="active">Stuur email naar school / melder</Label>
                                <div
                                    className='svg-pointer'
                                >
                                    <GroupStatus iconChangeHandler={(feild, value) => {
                                        if (parseInt(value) !== values.emailToSchool) {
                                            setFieldValue("emailToSchool", values.emailToSchool === 1 ? 0 : 1)
                                        }
                                    }} data={values.emailToSchool ? 1 : 0} />
                                </div>
                            </FormGroup>
                            <FormGroup className="d-flex justify-content-between">
                                <Label for="weekstaat">Stuur mail naar vervanger</Label>
                                <div
                                    className='svg-pointer'
                                >
                                    <GroupStatus iconChangeHandler={(feild, value) => {
                                        if (parseInt(value) !== values.emailToVervanger) {
                                            setFieldValue("emailToVervanger", values.emailToVervanger === 1 ? 0 : 1)
                                        }
                                    }} data={values.emailToVervanger ? 1 : 0} />
                                </div>
                            </FormGroup>

                            {errors.selection && (
                                <div className="text-danger">{errors.selection}</div>
                            )}


                            <ModalFooter className="d-flex align-items-center justify-content-center border-bottom-0 py-4 mt-4">
                                <Button className="btn-color-style opslaan-btn" size="sm" outline color="primary" type="submit" disabled={isSubmitting}>
                                    Opslaan
                                </Button>
                                <Button className="btn-color-style opslaan-btn" size="sm" outline color="primary" onClick={() => toggleEvalulerenModal()}>
                                    Sluiten
                                </Button>
                            </ModalFooter>
                        </Form>
                    )}
                </Formik>
            </ModalBody>
        </Modal>
    )
}

export default EvalulerenModal